import ns from '@rdf-esm/namespace';

function setNamespace(clazz, stringOrNamespace) {
  clazz.__ns = typeof stringOrNamespace === 'string' ? ns(stringOrNamespace) : stringOrNamespace;
}

const legacyNamespace = (stringOrNamespace, clazz) => {
  setNamespace(clazz, stringOrNamespace);
  return clazz;
};

const standardNamespace = (stringOrNamespace, descriptor) => {
  const {
    kind,
    elements
  } = descriptor;
  return {
    kind,
    elements,

    // This callback is called once the class is otherwise fully defined
    finisher(clazz) {
      setNamespace(clazz, stringOrNamespace);
    }

  };
};

export const namespace = stringOrNamespace => classOrDescriptor => typeof classOrDescriptor === 'function' ? legacyNamespace(stringOrNamespace, classOrDescriptor) : standardNamespace(stringOrNamespace, classOrDescriptor);